import React , { useState, useEffect, useContext} from "react";
import { animated } from "react-spring";
import styled from "styled-components"; // Import styled
import { Routes, Route , useNavigate, NavLink,Link} from "react-router-dom";
import { logout } from "../authenticate";
import { PriceContext} from '../context';


const PageContainer = styled.div`
height:100%;
  display: flex;
  width: 100%;
  min-height: 100% /* min-h-screen */
  flex-direction: column;
  justify-content: space-between;
  overflow-x: hidden;
  font-family: "Space Grotesk", "Noto Sans", sans-serif;

`;

// --- Sidebar Overlay (The dimming background) ---
const SidebarOverlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 50; /* z-50 */
  width: 100%;   /* size-full */
  height: 100%;  /* size-full */
  min-height: 100vh; /* min-h-screen */
`;

// --- Sidebar Content (The actual menu panel) ---
const SidebarContent = styled.div`
  display: flex;
  height: 100%;       /* h-full */
  min-height: 100vh;  /* min-h-screen */
  width: 99.
  .333333%;  /* w-10/12 (10/12 * 100%) */
  flex-direction: column;
  gap: 1rem;          /* gap-4 (16px) */
  background-color: #131516; /* bg-[#131516] - note: changed from #111518 in previous response */
  padding: 1rem;      /* p-4 (16px) */
`;

// --- Navigation List ---
const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem; /* gap-4 (16px) */
  list-style: none; /* Remove default list bullets */
  margin: 0;
  padding: 0;
`;

// --- Navigation List Item ---
const NavItem = styled.li`
  display: flex;
  height: 3rem; /* h-12 (48px) */
  align-items: center;
  gap: 1rem; /* gap-4 (16px) */
  border-radius: 9999px; /* rounded-full */
  padding: 0 1rem; /* px-4 */
  cursor: pointer; /* Indicate it's clickable */
  transition: background-color 0.2s ease; /* Smooth transition for hover/active */

  /* Specific styling for the 'Home' active state, if applicable */
  ${props => props.$isActive && `
    background-color: #2c3135; /* bg-[#2c3135] */
  `}

  &:hover {
    background-color: #2c3135; /* Apply hover background */
  }
`;

// --- Icon Wrapper within Nav Item ---
const NavIcon = styled.div`
  color: #fff; /* text-white */
  padding-right: 1rem; /* pr-4 */
  flex-shrink: 0; /* Ensures icon doesn't shrink */

  svg {
    width: 24px; /* data-size="24px" */
    height: 24px; /* data-size="24px" */
    fill: currentColor; /* Inherit color from parent */
  }
`;

// --- Nav Item Text ---
const NavText = styled.p`
  color: #fff; /* text-white */
  font-size: 1rem; /* text-base (16px) */
  font-weight: 700; /* font-bold */
  line-height: 1.25; /* leading-tight */
  white-space: nowrap; /* truncate */
  overflow: hidden;
  text-overflow: ellipsis;
`;

// --- Footer Spacer ---
const FooterSpacer = styled.div`
  height: 1.25rem; /* h-5 (20px) */
  background-color: #131516; /* bg-[#131516] - note: changed from #111518 in previous response */
`;


const SidebarMenu = ({handleDropdownClick}) => {

  const {email, isAuthenticated} = useContext(PriceContext);

  
  return (
    <PageContainer>
      {/* This outer div aligns with the original HTML structure's direct child */}
      <div>
        <SidebarOverlay>
          <SidebarContent>
            <NavList>


              {isAuthenticated ? (<>
                       <Link to="/"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem $isActive>

                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M224,115.55V208a16,16,0,0,1-16,16H168a16,16,0,0,1-16-16V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V115.55a16,16,0,0,1,5.17-11.78l80-75.48.11-.11a16,16,0,0,1,21.53,0,1.14,1.14,0,0,0,.11.11l80,75.48A16,16,0,0,1,224,115.55Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Home</NavText>
              </NavItem>
              </Link>


              {/* Paccount Item */}
              <Link to="/account"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" fill="none"></path>
<circle cx="12" cy="7" r="4" fill="none"></circle>
</svg>
       </NavIcon>
                <NavText>Account </NavText>
              </NavItem>
              </Link>
                 {/* Player Stats Item */}
              
      

{/* Pricing*/}

              <Link to="/pricing"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M152,120H136V56h8a32,32,0,0,1,32,32,8,8,0,0,0,16,0,48.05,48.05,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40h-8a48,48,0,0,0,0,96h8v64H104a32,32,0,0,1-32-32,8,8,0,0,0-16,0,48.05,48.05,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-40,0a32,32,0,0,1,0-64h8v64Zm40,80H136V136h16a32,32,0,0,1,0,64Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Pricing</NavText>
              </NavItem>
              </Link>
   



              {/* Pricing Item */}

              {/* Demo Item */}
              <Link to="/articles"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 448 512">
  <path
    d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1c11.8 0 23.2 4.7 31.8 13.4L434.6 96.2c8.7 8.7 13.4 20.2 13.4 32v294.7c0 2.2-1.8 4-4 4-2.2 0-4-1.8-4-4V128.9c-2.8-2.6-6.4-3.9-10.2-3.9H296c-13.3 0-24-10.7-24-24V41.8c0-3.8-1.3-7.4-3.9-10.2L249.2 13.4C240.5 4.7 229.1 0 217.3 0H48C34.3 0 24 10.3 24 24v440c0 13.7 10.3 24 24 24h352c13.7 0 24-10.3 24-24V128.9c0-3.8-1.3-7.4-3.9-10.2L329.8 13.4c-8.7-8.7-20.2-13.4-31.8-13.4H288z"
  ></path>
</svg>
                </NavIcon>
                <NavText>Articles</NavText>
              </NavItem>
              </Link>

                 {/* Player Stats Item */}
<Link to="/" style={{ textDecoration: 'none', color: 'inherit' }} onClick={() =>{ handleDropdownClick()
  logout()
}}>
              <NavItem>
                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Logout</NavText>
              </NavItem>
              </Link>
      

{email === "elijahizelllogan@gmail.com" && (
  <>
  <Link to="/admin" style={{ textDecoration: 'none', color: 'inherit' }} onClick={() => { handleDropdownClick() }}>
    <NavItem>
      <NavIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
          <path
            d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-4L195,66.69q-1.48-1.56-3-3L189.11,43a8,8,0,0,0-4-6,107.6,107.6,0,0,0-26.25-10.88,8,8,0,0,0-7.06,1.48L133.16,42.52q-2.16-.06-4.32,0L110.2,27.6a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,76.89,37,8,8,0,0,0,73,43L66.69,61q-1.56,1.48-3,3L43,66.89a8,8,0,0,0-6,4A107.6,107.6,0,0,0,26.12,97.14a8,8,0,0,0,1.48,7.06L42.52,122.84q-.06,2.16,0,4.32L27.6,145.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,4L61,189.31q1.48,1.56,3,3L66.89,213a8,8,0,0,0,4,6,107.6,107.6,0,0,0,26.25,10.88,8,8,0,0,0,7.06-1.48l18.64-14.92q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48A107.6,107.6,0,0,0,179.11,219a8,8,0,0,0,4-6L189.31,195q1.56-1.48,3-3L213,189.11a8,8,0,0,0,6-4,107.6,107.6,0,0,0,10.88-26.25,8,8,0,0,0-1.48-7.06Z"
          ></path>
        </svg>
      </NavIcon>
      <NavText>Admin</NavText>
    </NavItem>
  </Link>


  <Link to="/config" style={{ textDecoration: 'none', color: 'inherit' }} onClick={() => { handleDropdownClick() }}>
    <NavItem>
      <NavIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
          <path
            d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-4L195,66.69q-1.48-1.56-3-3L189.11,43a8,8,0,0,0-4-6,107.6,107.6,0,0,0-26.25-10.88,8,8,0,0,0-7.06,1.48L133.16,42.52q-2.16-.06-4.32,0L110.2,27.6a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,76.89,37,8,8,0,0,0,73,43L66.69,61q-1.56,1.48-3,3L43,66.89a8,8,0,0,0-6,4A107.6,107.6,0,0,0,26.12,97.14a8,8,0,0,0,1.48,7.06L42.52,122.84q-.06,2.16,0,4.32L27.6,145.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,4L61,189.31q1.48,1.56,3,3L66.89,213a8,8,0,0,0,4,6,107.6,107.6,0,0,0,26.25,10.88,8,8,0,0,0,7.06-1.48l18.64-14.92q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48A107.6,107.6,0,0,0,179.11,219a8,8,0,0,0,4-6L189.31,195q1.56-1.48,3-3L213,189.11a8,8,0,0,0,6-4,107.6,107.6,0,0,0,10.88-26.25,8,8,0,0,0-1.48-7.06Z"
          ></path>
        </svg>
      </NavIcon>
      <NavText>Config</NavText>
    </NavItem>
  </Link>

    <Link to="/checks" style={{ textDecoration: 'none', color: 'inherit' }} onClick={() => { handleDropdownClick() }}>
    <NavItem>
      <NavIcon>
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
          <path
            d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.6,107.6,0,0,0-10.88-26.25,8,8,0,0,0-6-4L195,66.69q-1.48-1.56-3-3L189.11,43a8,8,0,0,0-4-6,107.6,107.6,0,0,0-26.25-10.88,8,8,0,0,0-7.06,1.48L133.16,42.52q-2.16-.06-4.32,0L110.2,27.6a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,76.89,37,8,8,0,0,0,73,43L66.69,61q-1.56,1.48-3,3L43,66.89a8,8,0,0,0-6,4A107.6,107.6,0,0,0,26.12,97.14a8,8,0,0,0,1.48,7.06L42.52,122.84q-.06,2.16,0,4.32L27.6,145.8a8,8,0,0,0-1.48,7.06,107.6,107.6,0,0,0,10.88,26.25,8,8,0,0,0,6,4L61,189.31q1.48,1.56,3,3L66.89,213a8,8,0,0,0,4,6,107.6,107.6,0,0,0,26.25,10.88,8,8,0,0,0,7.06-1.48l18.64-14.92q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48A107.6,107.6,0,0,0,179.11,219a8,8,0,0,0,4-6L189.31,195q1.56-1.48,3-3L213,189.11a8,8,0,0,0,6-4,107.6,107.6,0,0,0,10.88-26.25,8,8,0,0,0-1.48-7.06Z"
          ></path>
        </svg>
      </NavIcon>
      <NavText>Checks</NavText>
    </NavItem>
  </Link>
  </>
)}

              </>): (<>
               
                         <Link to="/"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem $isActive>

                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M224,115.55V208a16,16,0,0,1-16,16H168a16,16,0,0,1-16-16V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V115.55a16,16,0,0,1,5.17-11.78l80-75.48.11-.11a16,16,0,0,1,21.53,0,1.14,1.14,0,0,0,.11.11l80,75.48A16,16,0,0,1,224,115.55Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Home</NavText>
              </NavItem>
              </Link>

              {/* Demo Item */}
              <Link to="/articles"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 448 512">
  <path
    d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1c11.8 0 23.2 4.7 31.8 13.4L434.6 96.2c8.7 8.7 13.4 20.2 13.4 32v294.7c0 2.2-1.8 4-4 4-2.2 0-4-1.8-4-4V128.9c-2.8-2.6-6.4-3.9-10.2-3.9H296c-13.3 0-24-10.7-24-24V41.8c0-3.8-1.3-7.4-3.9-10.2L249.2 13.4C240.5 4.7 229.1 0 217.3 0H48C34.3 0 24 10.3 24 24v440c0 13.7 10.3 24 24 24h352c13.7 0 24-10.3 24-24V128.9c0-3.8-1.3-7.4-3.9-10.2L329.8 13.4c-8.7-8.7-20.2-13.4-31.8-13.4H288z"
  ></path>
</svg>
                </NavIcon>
                <NavText>Articles</NavText>
              </NavItem>
              </Link>

              {/* Demo Item */}
              <Link to="/demo"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Demo</NavText>
              </NavItem>
              </Link>
              {/* Pricing Item */}
              <Link to="/pricing"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M152,120H136V56h8a32,32,0,0,1,32,32,8,8,0,0,0,16,0,48.05,48.05,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40h-8a48,48,0,0,0,0,96h8v64H104a32,32,0,0,1-32-32,8,8,0,0,0-16,0,48.05,48.05,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-40,0a32,32,0,0,1,0-64h8v64Zm40,80H136V136h16a32,32,0,0,1,0,64Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Pricing</NavText>
              </NavItem>
              </Link>

              {/* Sign Up Item */}
              <Link to="/signup"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>
              <NavItem>
                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M256,136a8,8,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A8,8,0,0,1,256,136Zm-57.87,58.85a8,8,0,0,1-12.26,10.3C165.75,181.19,138.09,168,108,168s-57.75,13.19-77.87,37.15a8,8,0,0,1-12.25-10.3c14.94-17.78,33.52-30.41,54.17-37.17a68,68,0,1,1,71.9,0C164.6,164.44,183.18,177.07,198.13,194.85ZM108,152a52,52,0,1,0-52-52A52.06,52.06,0,0,0,108,152Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Sign Up</NavText>
              </NavItem>
              </Link>
              {/* Login Item */}
              <Link to="/login"  style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleDropdownClick}>

              <NavItem>
                <NavIcon>
                  <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                    <path
                      d="M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z"
                    ></path>
                  </svg>
                </NavIcon>
                <NavText>Login</NavText>
              </NavItem>
              </Link>
              
              </>)}
              {/* Home Item (example of active state) */}
     
            </NavList>
          </SidebarContent>
        </SidebarOverlay>
      </div>
      {/* This empty div and FooterSpacer match the original HTML's structure */}
      <div><FooterSpacer /></div>
    </PageContainer>
  );
};




// Define your styled component for the navigation wrapper
const NavWrapper = styled(animated.div)`
  display:flex;
  flex-direction:column;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 100px;
  z-index: 700;
  height:100%
  width:100%;

  nav {
    /* Add styles for the nav element inside NavWrapper if needed */
    display: flex; /* Example: to arrange links horizontally */
    flex-direction: column;
    justify-content: space-around; /* Example: to space out links */
    align-items: center;
    height: 100%/* Example: to center vertically within the wrapper */
  }

  a {
    /* Add styles for your anchor tags here */
    color: blue; /* Example: link color */
    text-decoration: none; /* Example: remove underline */
    font-size: 1.5em; /* Example: font size */
    margin: 0 15px; /* Example: spacing between links */
    &:hover {
      text-decoration: underline; /* Example: hover effect */
    }
  }
`;

const SpringNav = ({ style, handleDropdownClick}) => {
  const [browserWidth, setBrowserWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    // Function to update the width state
    const handleResize = () => {
      setBrowserWidth(window.innerWidth);
    };

    // Add event listener when the component mounts
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // The empty dependency array ensures this effect runs only once on mount and cleans up on unmount

  return (
    // Use the styled component and pass the style prop to it
    <NavWrapper style={style} width={browserWidth}>

   <SidebarMenu handleDropdownClick={handleDropdownClick}/>
    </NavWrapper>
    
  );
};

export default SpringNav;